/**
 * Venue Inventory — search + browse this venue's logged found items.
 *
 * v1: placeholder shell. Full implementation pending — needs:
 *   - Natural-language search ("black iPhone last week")
 *   - Type-filter chips
 *   - Reference-code lookup
 *   - Item detail drill-in
 *
 * For now, communicates "this is coming" without breaking the IA.
 */

export default function VenueInventory() {
  return (
    <div className="flex-1 min-h-0 flex flex-col">
      <header className="shrink-0 pt-6 pb-2 text-center">
        <p className="text-[10px] font-medium tracking-[0.18em] uppercase" style={{ color: 'var(--text-ghost)' }}>
          The Lost Club · Venue
        </p>
        <h1 className="mt-2 text-xl font-semibold" style={{ color: 'var(--text-primary)' }}>
          Inventory
        </h1>
      </header>

      <div className="flex-1 min-h-0 flex flex-col items-center justify-center px-6">
        <div className="text-center max-w-sm">
          <div
            className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-4"
            style={{ background: 'var(--accent-muted)', color: 'var(--accent)' }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </div>
          <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
            Search your inventory
          </h2>
          <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
            Coming soon. Search by description, ticket code, or category — your venue's found items in one place.
          </p>
        </div>
      </div>
    </div>
  )
}
